import abiImport from "./IBracketOracle.json";

export const abi = abiImport;
export * from "./IBracketOracle";
